<template>
  <div ref="main" class="chat-main chat-flex-1">
    <ul>
      <ChatMessageItem
          v-for="(message,idx) in list"
          :key="idx" :message="message" :role="role"/>
    </ul>
  </div>
</template>

<script>
import ChatMessageItem from '@/components/ChatMessageItem';

export default {
  name: 'ChatMessageList',
  components: {ChatMessageItem},
  props: {
    list: Array,
    type: String,
    role: String,
  },
  computed: {
    lastType({type, list}) {
      if (type) {
        return type;
      }
      const {length} = list;
      return length ? list[length - 1].type : null;
    },
  },
  updated() {
    setTimeout(() => {
      const {$refs: {main} = {}} = this;
      if (main) {
        const {offsetHeight, scrollHeight} = main;
        main.scrollTop = scrollHeight - offsetHeight;
      }
    });
  },
};
</script>

<style scoped lang="scss">
$h-padding: 20px;

.chat-main {
  padding: 8px $h-padding;
  box-sizing: border-box;
  overflow: auto;
}
</style>